export default __webpack_public_path__ + "2_select_mobile.png";